import QuotationHistory from "./quotation-history.container";

export default QuotationHistory;
